<ng-container *ngIf="!isInternational &&
  !isClientProcessed &&
  (paymentStatus !== PaymentStatuses.Voided) &&
  (paymentStatus !== PaymentStatuses.Fulfilled) &&
  (paymentStatus !== PaymentStatuses.Outstanding)">
  <div *ngIf="addressRequestStatus">
    <yc-fa *ngIf="!textOnly"
      icon="star"
      [light]="true"
      class="me-2"
      [class.text-warning]="addressRequestStatus === AddressRequestStatus.Pending ||
        addressRequestStatus === AddressRequestStatus.OnHold"
      [class.text-success]="addressRequestStatus === AddressRequestStatus.Approved"
      [class.text-danger]="addressRequestStatus === AddressRequestStatus.Rejected">
    </yc-fa>
    <ng-container *ngIf="!iconOnly">
      {{ addressRequestStatusMap[addressRequestStatus] }}
    </ng-container>
  </div>
  <div *ngIf="!addressRequestStatus &&
    hasAddressRequest">
    <yc-fa *ngIf="!textOnly"
      icon="star"
      [light]="true"
      class="text-warning me-2">
    </yc-fa>
    <yc-i18n *ngIf="!iconOnly"
      key="GLOBAL:textAlternateAddressRequestPending2"
      defaultValue="Alternate address request pending">
    </yc-i18n>
  </div>
</ng-container>